const LOCAL_STORAGE_KEY = {
    REFRESH_TOKEN: 'autentika_app_refresh_token',
    TOKEN: 'autentika_app_token',
    ADMIN_ROLE: 'admin_role_access',
    EMAIL: 'email_user',
}


export default LOCAL_STORAGE_KEY;